import styled from 'styled-components';
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EditIcon from '@mui/icons-material/Edit';
// Base styled components
export const Container = styled.div`
  margin-bottom: 16px;
`;

interface TextProps {
  size?: string;
  weight?: string | number;
  primary?: boolean;
}

export const StyledDeleteIcon = styled(DeleteOutlinedIcon)({
  fontSize: "24px",
  color: "#E39435",
  cursor: "pointer",
});

// Styled components
export const Title = styled.h2`
  font-size: 18px;
  font-weight: 400;
  color: #1e2f23;
  margin: 0 0 16px 0;
`;

// Responsive wrapper for mobile view
export const ResponsiveContainer = styled.div`
  @media (max-width: 375px) {
    padding: 0 16px;
  }
`;


export const Text = styled.span<TextProps>`
  color: #1e2f23;
  font-size: ${props => props.size || '16px'};
  font-weight: ${props => props.weight || '400'};
`;


export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface FileInputContainerProps {
  $isFromProfile?: boolean;
}

export const FileInputContainer = styled(FlexContainer)<FileInputContainerProps>`
  background: ${props => props.$isFromProfile ? 'transparent' : 'rgba(132, 73, 2, 0.08)'};
  width: 100%;
  min-height: ${props => props.$isFromProfile ? 'auto' : '74px'};
  border-radius: 4px 4px 0px 0px;
  padding: ${props => props.$isFromProfile ? '0' : '8px 16px'};
  margin-bottom: 16px;
  justify-content: space-between;
  
  @media (max-width: 767px) {
    width: 100%;
    min-width: 260px;
  }
`;

export const ContentWrapper = styled.div`
  width: calc(100% - 48px);
`;

export const LabelText = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
`;

export const FileNameDisplay = styled(Text)`
  font-weight: 700;
`;

export const UploadLabel = styled.label`
  min-width: 42px;
  cursor: pointer;
  display:flex;
`;

interface HiddenInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  multiple?: boolean;
}

export const HiddenInput = styled.input.attrs<HiddenInputProps>({
  type: 'file'
})<HiddenInputProps>`
  display: none;
`;

export const FileUploadIconStyled = styled(FileUploadIcon)`
  font-size: 23px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 8px;
  cursor: pointer;
`;

export const FileDownloadIconStyled = styled(FileDownloadIcon)`
  font-size: 23px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 8px;
  cursor: pointer;
`;

export const EditIconStyled = styled(EditIcon)`
  font-size: 23px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 8px;
  cursor: pointer;
`;

// Alternative approach with more granular components
interface TypographyProps {
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  bold?: boolean;
  color?: string;
  mb?: string;
}

export const Typography = styled.span.attrs<TypographyProps>(({ as: Component = 'div' }) => ({
  as: Component
}))<TypographyProps>`
  color: ${props => {
    if (props.variant === 'primary') return "#E39435";
    return '#1e2f23';
  }};
  font-size: ${props => {
    switch (props.size) {
      case 'small': return '12px';
      case 'medium': return '16px';
      case 'large': return '18px';
      default: return '16px';
    }
  }};
  font-weight: ${props => props.bold ? '700' : '400'};
  margin-bottom : ${props => props.mb ? props.mb : '8px'}
`;

interface BoxProps {
  $mb?: string;
  $maxWidth?: string;
  $width?: string;
  $padding?: string;
  $background?: string;
  $borderRadius?: string;
  $minHeight?: string;
  $textOverflow?: string;
  $overflow?: string;
  $whiteSpace?: string;
  $justifyContent?: string;
  $alignItems?: string;
}

export const Box = styled.div<BoxProps>`
  margin-bottom: ${props => props.$mb || '0px'};
  max-width: ${props => props.$maxWidth || 'none'};
  width: ${props => props.$width || 'auto'};
  padding: ${props => props.$padding || '0'};
  background: ${props => props.$background || 'transparent'};
  border-radius: ${props => props.$borderRadius || '0'};
  min-height: ${props => props.$minHeight || 'auto'};
  text-overflow: ${props => props.$textOverflow || 'clip'};
  overflow: ${props => props.$overflow || 'visible'};
  white-space: ${props => props.$whiteSpace || 'normal'};
  display: ${props => (props.$justifyContent || props.$alignItems) ? 'flex' : 'block'};
  justify-content: ${props => props.$justifyContent || 'flex-start'};
  align-items: ${props => props.$alignItems || 'stretch'};
`;

interface FlexProps extends BoxProps {
  alignItems?: string;
  justifyContent?: string;
}

export const Flex = styled(Box)<FlexProps>`
  display: flex;
  align-items: ${props => props.alignItems || 'stretch'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
`;